import CardLinkApp from '@/src/card-linking/components/CardLinkApp'
import { TCardLinkFunctions } from '@/src/card-linking/types'
import { UseMutationResult } from 'react-query'

interface ICardLinkModal {
    functions: TCardLinkFunctions
    deleteCard: UseMutationResult<any, any, any, any>
    cardToCardUuid: string
    hideGiftDetailsButton?: boolean
    initialStep?: 'INITIAL' | 'REMOVE_OR_ADD_CARDS'
}

const CardLinkModalContent = ({
    functions,
    hideGiftDetailsButton = false,
    initialStep,
    deleteCard,
    cardToCardUuid,
}: ICardLinkModal) => {
    return (
        <CardLinkApp
            functions={functions}
            hideGiftDetailsButton={hideGiftDetailsButton}
            initialStep={initialStep}
            deleteCard={deleteCard}
            cardToCardUuid={cardToCardUuid}
        />
    )
}

export default CardLinkModalContent
